import axios from 'axios';

const api = axios.create({
  baseURL: '/api/', // Указываем относительный путь что бы запросы шли через домен
  headers: {
    'Content-Type': 'application/json',
  },
});

// 👉 1. Подставляем access токен в каждый запрос
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 👉 2. Интерцептор для обработки 401 и обновления access токена
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const isAuthEndpoint = originalRequest?.url?.includes('/auth/jwt/create/') ||
      originalRequest?.url?.includes('/auth/jwt/refresh/');

    // Не обрабатывать 401 для логина/обновления токена — пусть форма логина покажет ошибку
    if (isAuthEndpoint) {
      return Promise.reject(error);
    }

    // Если токен истёк и запрос не повторялся
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then((token) => {
          originalRequest.headers.Authorization = 'Bearer ' + token;
          return api(originalRequest);
        });
      }

      isRefreshing = true;
      const refreshToken = localStorage.getItem('refresh');

      if (!refreshToken) {
        localStorage.clear();
        window.location.href = '/login'; // перекинуть на логин
        return Promise.reject(error);
      }

      try {
        const refreshResponse = await axios.post('/api/auth/jwt/refresh/', {
          refresh: refreshToken,
        });

        const newAccessToken = refreshResponse.data.access;
        localStorage.setItem('access', newAccessToken);

        // обновим авторизацию для будущих запросов
        api.defaults.headers.Authorization = `Bearer ${newAccessToken}`;
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

        processQueue(null, newAccessToken);

        return api(originalRequest);
      } catch (err) {
        processQueue(err, null);
        localStorage.clear();
        window.location.href = '/login';
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export const getPostSummary = (postId) =>
  api.post(`ai/posts/${postId}/summary/`);

export const getRepeatTrip = (postId) =>
  api.post(`ai/posts/${postId}/repeat-trip/`);

export default api;
